export default function ButtonActionEditor({ button, onChange }) {

  function update(field, value) {
    onChange({ ...button, [field]: value });
  }

  function updateAction(field, value) {
    onChange({
      ...button,
      action: { ...button.action, [field]: value }
    });
  }

  return (
    <div style={{
      border: "1px dashed #94a3b8",
      padding: 8,
      borderRadius: 6,
      marginTop: 6
    }}>

      <input
        value={button.label}
        onChange={e => update("label", e.target.value)}
        placeholder="Button label"
        style={{ width: "100%" }}
      />

      <select
        value={button.action.type}
        onChange={e => updateAction("type", e.target.value)}
        style={{ width: "100%", marginTop: 6 }}
      >
        <option value="REDIRECT_URL">Redirect to URL</option>
        <option value="NEXT_STEP">Next Message (Canvas)</option>
        <option value="START_FLOW">Start Another Flow</option>
      </select>

      {button.action.type === "REDIRECT_URL" && (
        <input
          placeholder="https://..."
          value={button.action.value || ""}
          onChange={e => updateAction("value", e.target.value)}
          style={{ width: "100%", marginTop: 6 }}
        />
      )}

      {button.action.type === "START_FLOW" && (
        <input
          placeholder="Flow Key (e.g DEMO_CLASS)"
          value={button.action.value || ""}
          onChange={e => updateAction("value", e.target.value)}
          style={{ width: "100%", marginTop: 6 }}
        />
      )}

      <div style={{ fontSize: 12, color: "#64748b", marginTop: 4 }}>
        Action: {button.action.type}
      </div>

    </div>
  );
}
